import React from 'react';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';
import { DropdownComponent } from '../../../../../components/prime-formik';

const SuperProfileOccupationalLevelInput = () => {
  const { setFieldValue } = useFormikContext();

  const occupationalLevelOptions = [
    { label: 'Intern/Student', value: 'INTERN_STUDENT' },
    { label: 'Freelancer', value: 'FREELANCER' },
    { label: 'Temporary employee', value: 'TEMPORARY_EMPLOYEE' },
    { label: 'Employee', value: 'EMPLOYEE' },
    { label: 'Manager', value: 'MANAGER' },
    { label: 'Leader', value: 'LEADER' },
    { label: 'Other', value: 'OTHER' },
  ];

  return (
    <div className="p-col-12">
      <div>
        <strong>Match candidates against these Qualifications & Requirements (Q&R)</strong>
      </div>
      <div className="flex-space-between">
        <FormattedMessage
          id="account.super-profiles.new.occupational-level"
          defaultMessage="Occupational level"
        >
          {(text) => (
            <label className="field-label" htmlFor="occupationalLevel">
              {text}
            </label>
          )}
        </FormattedMessage>
        <FormattedMessage id="select" defaultMessage="Select">
          {(text) => (
            <Field
              id="occupationalLevel"
              name="occupationalLevel"
              component={DropdownComponent}
              options={occupationalLevelOptions}
              filter
              filterBy="label,value"
              className="right"
              onChange={(event) => {
                setFieldValue('occupationalLevel', event.value);
              }}
              placeholder={`-- ${text} --`}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

export default SuperProfileOccupationalLevelInput;
